import { createFileRoute } from "@tanstack/react-router";
import TicaAntier from "@/pages/TicaAntier";
import { loadResultsSummary } from "@/lib/results-seo";

export const Route = createFileRoute("/tica-antier")({
  loader: ({ context }) => loadResultsSummary(context.queryClient, 2),
  head: ({ loaderData }) => {
    const s = loaderData ?? { dateLabel: "", tica: "", nica: "" };
    const title = `Tica Antier ${s.dateLabel}${s.tica ? `: ${s.tica}` : ""} | Tiempos JPS Costa Rica`;
    const description = `Resultados Tiempos JPS Costa Rica antier ${s.dateLabel}: ${s.tica || "sorteos de 1pm, 4:30pm y 7:30pm"}. Con Bolita Blanca o Reventado.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://tiemposhoy.com/tica-antier" },
        { name: "twitter:card", content: "summary" },
      ],
      links: [{ rel: "canonical", href: "https://tiemposhoy.com/tica-antier" }],
    };
  },
  component: TicaAntier,
});
